module.exports = __webpack_public_path__ + "img/aeroland-pricing-image-07.2a3a7299.png";